import { defineComponent as _defineComponent } from 'vue'
import commonModule from "@/composables/modules/commonModule";
    
    
export default /*@__PURE__*/_defineComponent({
  __name: 'commonForm',
  props: {
        actionUrl: { type: String, required: true },
        v$: Object,
        successCallBack: { type: Function, default: null },
        failureCallBack: { type: Function, default: null },
        beforeSubmit: { type: Function, default: null },
        method: {type: String, default:"PostData"},
        data: { type: Object, required: true },
        successMessage: { type: String, default: "" },
        dataId: { type: Number, default: 0 },
        dataUrl: { type: String, default: "" }
    },
  setup(__props, { expose: __expose }) {

    const { GetData, PostData, PostFormData  } = new commonModule();
    const Props = __props;
    const SubmitData = async (e: any) => {
        if (Props.beforeSubmit) {
            Props.beforeSubmit();
        }
        const result = await Props.v$.value.$validate();
        if (((Props.v$?.value?.$silentErrors ?? []).length || 0) > 0) 
        {
            return;
        }
        if (result) {
            if(Props.method === "PostData"){
                PostData(Props.actionUrl, Props.data, Props.successMessage, (data: any) => {
                    if(Props.successCallBack)
                        Props.successCallBack(data);
                }, (data: any) => {
                    if(Props.failureCallBack)
                        Props.failureCallBack(data.Message);
                }); 
            }
            else if(Props.method === "PostFormData"){
                PostFormData(Props.actionUrl, Props.data, (data: any) => {
                    if(Props.successCallBack)
                        Props.successCallBack(data);
                }, (data: any) => {
                    if(Props.failureCallBack)
                        Props.failureCallBack(data.Message);
                }); 
            }
        }
        else{
            if ((Props.v$.value.$silentErrors.length || 0) > 0) {
                if (e.target[Props.v$.value.$silentErrors[0].$property])
                    e.target[Props.v$.value.$silentErrors[0].$property].focus();
            }
        }
    }
    const SetValidation = async (callback: any) => {
        if (Props.dataId > 0) {
            let GetDataUrl = Props.dataUrl;
            if (!Props.dataUrl || Props.dataUrl == "")
                GetDataUrl = Props.actionUrl + Props.dataId;
            GetData(GetDataUrl, (data: any) => {
                callback(data);
            });
        }
        else {
            callback(Props.data);
        }
    }
    __expose({ SetValidation })

const __returned__ = { GetData, PostData, PostFormData, Props, SubmitData, SetValidation }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})